import { getGA4Context } from '../../helpers';
import { tracker } from '../track';
export const trackCloseFilter = ({ element, context, filterLvl, filtersValue, campaignId, }) => {
    const closeFilter = {
        context: context || getGA4Context(),
        element,
        filter_lvl: filterLvl !== null && filterLvl !== void 0 ? filterLvl : null,
        filters_value: filtersValue,
        promotion_id: campaignId || null,
    };
    tracker.track('GA4-close_filter', {
        event_name: 'close_filter',
        close_filter: closeFilter,
    });
};
